<template>
  <v-app>
    <header-component @handleDrawer="handleDrawer" />
    <sidebar-component :drawer="drawer" />
    <v-main>
      <router-view />
    </v-main>
    <footer-component />
  </v-app>
</template>

<script>
import HeaderComponent from "./components/HeaderComponent.vue";
import FooterComponent from "./components/FooterComponent.vue";
import SidebarComponent from "./components/SidebarComponent.vue";

export default {
  name: "App",
  components: {
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
  },
  data: () => ({ drawer: false }),
  methods: {
    handleDrawer() {
      this.drawer = !this.drawer;
    },
  },
};
</script>

<style>
@import url("https://fonts.cdnfonts.com/css/poppins");
@import url("https://fonts.cdnfonts.com/css/noto-sans");
@import url("https://fonts.cdnfonts.com/css/helvetica-neue-9");

* {
  font-family: "Poppins 500", "Noto Sans Regular", "Helvetica Neue", Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
